import React from "react";
import { inject } from "mobx-react";
import { Tabs } from "antd";
import BasicInfo from "./basicInfo";
import ApplicantList from "./applicantList";
import MemberList from "./memberList";

import Language from "../../../language/language";
import { $const } from "../../../../helper";
import "../../stylesheets/teamInfoTabs.scss";

@inject("teamStore")
class InfoTabs extends React.Component {
  state = {
    isLoading: true
  };

  getTeamMembersNum = teamInfo => {
    if (teamInfo && teamInfo.gteamMembers && teamInfo.gteamMembers.nodes) {
      return teamInfo.gteamMembers.nodes.length;
    }
    return 0;
  };

  getTeamApplicantsNum = teamInfo => {
    if (teamInfo && teamInfo.gapplications && teamInfo.gapplications.nodes) {
      return teamInfo.gapplications.nodes.reduce((pre, cur) => {
        if (cur.status === $const.TEAM_APPLICATION_STATUS.PENDING) {
          return pre + 1;
        }
        return pre;
      }, 0);
    }
    return 0;
  };

  render() {
    const teamInfo = this.props.teamStore.teamInfo;
    const schoolsInfo = this.props.schoolsInfo;
    const membersNum = this.getTeamMembersNum(teamInfo);
    const applicantsNum = this.getTeamApplicantsNum(teamInfo);
    // 战队信息能否编辑  (未锁定 /开放状态)
    const isEditing = this.props.isEditing;
    const canCaptainEdit =
      (teamInfo.status === $const.TEAM_STATUS.UNLOCKED ||
        (teamInfo.status === $const.TEAM_STATUS.EDIT && isEditing)) &&
      teamInfo.isCaptain;

    // 副队长能编辑的信息
    const canSubCaptainEdit =
      (teamInfo.status === $const.TEAM_STATUS.UNLOCKED ||
        (teamInfo.status === $const.TEAM_STATUS.EDIT && isEditing)) &&
      teamInfo.isSubCaptain;

    const currentTeamIsSpecialGame = this.props.teamStore.currentTeamIsSpecialGame;

    return (
      <Tabs defaultActiveKey="basicInfo" animated={false} className="teamInfoTabs">
        <Tabs.TabPane tab={<Language resource="TEAM_INFO"></Language>} key="basicInfo">
          <BasicInfo
            className="teamInfoTabs--content-box"
            info={teamInfo}
            schoolsInfo={schoolsInfo}
          />
        </Tabs.TabPane>
        {!currentTeamIsSpecialGame ? (
          <Tabs.TabPane
            tab={<Language resource="TEAMMEMBER_LIST_NUM" keys={[membersNum]}></Language>}
            key="memberList"
          >
            <MemberList
              className="teamInfoTabs--content-box"
              teamInfo={teamInfo}
              canCaptainEdit={canCaptainEdit}
              canSubCaptainEdit={canSubCaptainEdit}
            />
          </Tabs.TabPane>
        ) : null}
        {!currentTeamIsSpecialGame && (canCaptainEdit || canSubCaptainEdit) && applicantsNum > 0 ? (
          <Tabs.TabPane
            tab={<Language resource="APPLICANT_LIST_NUM" keys={[applicantsNum]}></Language>}
            key="applicantList"
          >
            <ApplicantList className="teamInfoTabs--content-box" />
          </Tabs.TabPane>
        ) : null}
      </Tabs>
    );
  }
}

export default InfoTabs;



// WEBPACK FOOTER //
// ./src/components/common/teamInfo/teamInfoTabs/index.js